import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
const VendorQuotationEntry = () => {
    const [rfqs, setRfqs] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [rfqItems, setRfqItems] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
    const [rows, setRows] = useState([
        {
            item_id: '',
            product: '',
            qty: 1,
            rate: 0,
            gst: 0,
            net_amount: 0
        }
    ]);
    const [formData, setFormData] = useState({
        rfq: '',
        vendor: '',
        quotation_no: '',
        quotation_date: ''
    });
    useEffect(() => {
        fetchRFQ();
        fetchVendors();
    }, []);
    const fetchRFQ = () => {
        axios
            .get(`${baseUrl}rfq/`)
            .then(res => {
                setRfqs(res.data);
            });
    };
    const fetchVendors = () => {
        axios
            .get(`${baseUrl}add-supplier/`)
            .then(res => {
                setVendors(res.data);
            });
    };
    const fetchRFQItems = (rfqId) => {
        axios
            .get(`${baseUrl}rfq-items/${rfqId}/`)
            .then(res => {
                setRfqItems(res.data);
            });
    };
    const handleDateChange = (date) => {
        if (date) {
            const dateString = date.toISOString().slice(0, 10);
            const dateObj = new Date(dateString);
            dateObj.setHours(0, 0, 0, 0);
            setSelectedDate(dateObj);
        }
    };
    const handleRFQ = (e) => {
        const rfq = e.target.value;
        setFormData({
            ...formData,
            rfq: rfq
        });
        fetchRFQItems(rfq);
    };
    const handleProduct = (e, index) => {
        const itemId = e.target.value;
        const item = rfqItems.find(
            x => x.id == itemId
        );
        const newRows = [...rows];
        newRows[index].item_id = item.id;
        newRows[index].product = item.product;
        newRows[index].qty = item.qty;
        setRows(newRows);
    };
    const handleRow = (e, index) => {
        const {name, value} = e.target;
        const newRows = [...rows];
        newRows[index][name] = value;
        const qty = parseFloat(
            newRows[index].qty || 0
        );
        const rate = parseFloat(
            newRows[index].rate || 0
        );
        const gst = parseFloat(
            newRows[index].gst || 0
        );
        const subtotal = qty * rate;
        const gstAmount =
            (subtotal * gst) / 100;
        newRows[index].net_amount =
            subtotal + gstAmount;
        setRows(newRows);
    };
    const addRow = () => {
        setRows([
            ...rows,
            {
                item_id: '',
                product: '',
                qty: 1,
                rate: 0,
                gst: 0,
                net_amount: 0
            }
        ]);
    };
    const deleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.rfq) {
            Swal.fire(
                'Error',
                'Select RFQ',
                'error'
            );
            return;
        }
        if (!formData.vendor) {
            Swal.fire(
                'Error',
                'Select Vendor',
                'error'
            );
            return;
        }
        const validRows = rows.filter(
            row => row.product
        );
        if (validRows.length === 0) {
            Swal.fire(
                'Error',
                'Add Products',
                'error'
            );
            return;
        }
        const total = validRows.reduce(
            (a, b) =>
                a + parseFloat(b.net_amount || 0),
            0
        );
        const _formData = new FormData();
        _formData.append(
            'rfq',
            formData.rfq
        );
        _formData.append(
            'vendor',
            formData.vendor
        );
        _formData.append(
            'quotation_no',
            formData.quotation_no
        );
        _formData.append('quotation_date', selectedDate.toISOString().slice(0, 10));
        _formData.append(
            'total_amount',
            total
        );
        _formData.append(
            'addedby',
            userName
        );
        _formData.append(
            'location',
            userLocation
        );
        _formData.append(
            'ip_add',
            ipAddress
        );
        _formData.append(
            'item_id',
            validRows.map(
                row => row.item_id
            ).join(',')
        );
        _formData.append(
            'product',
            validRows.map(
                row => row.product
            ).join(',')
        );
        _formData.append(
            'qty',
            validRows.map(
                row => row.qty
            ).join(',')
        );
        _formData.append(
            'rate',
            validRows.map(
                row => row.rate
            ).join(',')
        );
        _formData.append(
            'gst',
            validRows.map(
                row => row.gst
            ).join(',')
        );
        _formData.append(
            'net_amount',
            validRows.map(
                row => row.net_amount
            ).join(',')
        );
        _formData.append(
            'is_lowest',
            validRows.map(
                row => false
            ).join(',')
        );
        axios.post(
            `${baseUrl}vendor-quotation-create/`,
            _formData
        )
            .then(response => {
                Swal.fire({
                    title: 'Success',
                    text: 'Quotation Saved',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch(error => {
                console.log(
                    error.response?.data
                );
                Swal.fire(
                    'Error',
                    'Failed To Save',
                    'error'
                );
            });
    };
    return (
        <section className='container mt-4'>

            <h3
                className="text-center"
                style={{
                    color: 'black',
                    backgroundColor: '#e5eaef',
                    padding: '10px'
                }}
            >
                Vendor Quotation Entry
            </h3>

            <div className='row'>

                <div className='col-md-3 mb-3'>

                    <label>
                        RFQ
                    </label>

                    <select
                        className='form-control'
                        onChange={handleRFQ}
                    >

                        <option value=''>
                            Select RFQ
                        </option>

                        {rfqs.map((item, index) => (
                            <option
                                key={index}
                                value={item.id}
                            >
                                {item.rfq_no}
                            </option>
                        ))}

                    </select>

                </div>

                <div className='col-md-3 mb-3'>

                    <label>
                        Vendor
                    </label>

                    <select
                        className='form-control'
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                vendor: e.target.value
                            })
                        }
                    >

                        <option value=''>
                            Select Vendor
                        </option>

                        {vendors.map((item, index) => (
                            <option
                                key={index}
                                value={item.id}
                            >
                                {item.name}
                            </option>
                        ))}

                    </select>

                </div>

                <div className='col-md-3 mb-3'>

                    <label>
                        Quotation No
                    </label>

                    <input
                        className='form-control'
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                quotation_no: e.target.value
                            })
                        }
                    />

                </div>

                <div className='col-md-3 mb-3'>

                    <label>
                        Invoice Date
                    </label>

                    <div>

                        <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange}
                                    dateFormat="yyyy-MM-dd"/>
                    </div>

                </div>

            </div>

            <div className='table-responsive mt-4'>

                <table className="erp-table-modern">

                    <thead>

                    <tr
                        style={{
                            backgroundColor: '#1bc5ce',
                            color: 'white'
                        }}
                    >

                        <th style={{width: 350}}>
                            Product
                        </th>

                        <th style={{width: 150}}>
                            Qty
                        </th>

                        <th style={{width: 250}}>
                            Rate
                        </th>

                        <th style={{width: 150}}>
                            GST %
                        </th>

                        <th style={{width: 250}}>
                            Net Amount
                        </th>

                        <th>
                            Action
                        </th>

                    </tr>

                    </thead>

                    <tbody>

                    {rows.map((row, index) => (
                        <tr key={index}>

                            <td>

                                <select
                                    className='form-control'
                                    onChange={(e) =>
                                        handleProduct(e, index)
                                    }
                                >

                                    <option value=''>
                                        Select Product
                                    </option>

                                    {rfqItems.map((item, i) => (
                                        <option
                                            key={i}
                                            value={item.id}
                                        >
                                            {item.product}
                                        </option>
                                    ))}

                                </select>

                            </td>

                            <td>

                                <input
                                    type='number'
                                    name='qty'
                                    className='form-control'
                                    value={row.qty}
                                    onChange={(e) =>
                                        handleRow(e, index)
                                    }
                                />

                            </td>

                            <td>

                                <input
                                    type='number'
                                    name='rate'
                                    className='form-control'
                                    value={row.rate}
                                    onChange={(e) =>
                                        handleRow(e, index)
                                    }
                                />

                            </td>

                            <td>

                                <input
                                    type='number'
                                    name='gst'
                                    className='form-control'
                                    value={row.gst}
                                    onChange={(e) =>
                                        handleRow(e, index)
                                    }
                                />

                            </td>

                            <td>

                                <input
                                    type='number'
                                    className='form-control'
                                    value={row.net_amount}
                                    readOnly
                                />

                            </td>

                            <td>

                                <button
                                    type='button'
                                    className='btn btn-danger btn-sm'
                                    onClick={() =>
                                        deleteRow(index)
                                    }
                                >

                                    Delete

                                </button>

                            </td>

                        </tr>
                    ))}

                    </tbody>

                </table>

                <div className='mt-3'>

                    <button
                        type='button'
                        className='btn btn-success'
                        onClick={addRow}
                    >

                        Add Row

                    </button>

                    <button
                        type='button'
                        className='btn btn-primary ms-3'
                        onClick={formSubmit}
                    >

                        Submit

                    </button>

                </div>

            </div>

        </section>
    );
};
export default VendorQuotationEntry;